import React, {Component} from 'react';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import {IconButton, Menu, MenuItem} from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import {NavLink} from 'react-router-dom';

class SignedInLinks extends Component {
    state = {
        anchorEl: null
    }

    handleMenu = e => {
        this.setState({
            anchorEl: e.currentTarget
        });
    };

    handleClose = route => {
        this.setState({
            anchorEl: null
        });
    }

    render() {
        const {anchorEl} = this.state;
        const open = Boolean(anchorEl);
        const {classes} = this.props;

        return (
            <div>
                <NavLink className={classes.resetLinkStyle} to="/playground">
                    <Button color="inherit">Playground</Button>
                </NavLink>
                <IconButton
                    aria-owns={open ? "menu-appbar" : undefined}
                    aria-haspopup="true"
                    color="inherit"
                    onClick={this.handleMenu}
                >
                    <AccountCircle/>
                </IconButton>

                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    open={open}
                    onClose={this.handleClose}
                >
                    <NavLink className={classes.resetLinkStyle} to="/">
                        <MenuItem onClick={this.handleClose}>
                            Home
                        </MenuItem>
                    </NavLink>
                    <NavLink className={classes.resetLinkStyle} to="/manual-book">
                        <MenuItem onClick={this.handleClose}>
                            Manual Book
                        </MenuItem>
                    </NavLink>
                    <NavLink className={classes.resetLinkStyle} to="/about">
                        <MenuItem onClick={this.handleClose}>
                            About
                        </MenuItem>
                    </NavLink>
                </Menu>
            </div>
        );
    }
};

const styles = {
    resetLinkStyle: {
        textDecoration: 'none',
        color: 'white'
    }
}

export default withStyles(styles)(SignedInLinks);